import React from 'react';
import {
  ButtonOBSOLETED,
  SimpleDataTable as DataTable
} from '../../../../../web.common';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../../../../common/withRouter';
import AriaModal from 'react-aria-modal';
import withApi from '../../../../higherOrderComponents/withApi';
import { CreateProductField } from './CreateProductField';
import { EditProductField } from './EditProductField';
import {
  DisplayGuid,
  DisplayBoolean,
  DisplayType
} from '../../../../items';

const resultsCount = 15;

class ProductFieldsInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
  }

  async loadData(skipPages) {
    const {
      props: {
        api: { products: { searchProductFields } },
        productId
      }
    } = this;

    let result = null;

    try {
      result = await searchProductFields({
        filters: {
          ProductId: productId
        },
        skipPages,
        resultsCount
      }
      );
    }
    catch (e) {
      console.error(`unable to load. ${e}`);

      return;
    }

    return result;
  }

  reloadList() {
    this.setState({
      reload: true
    });
  }

  shouldReloadList() {
    const {
      page,
      reloadPage,
      reload
    } = this.state;
    return (page !== reloadPage) || reload;
  }

  // TODO: get rid of workaround by consuming datalist in a sub component
  // or by fixing simpledatalist in order to reload data when the page has changed
  reloadWorkaround() {
    const { page } = this.state;

    this.setState({
      reloadPage: page,
      reload: false
    });

    return '';
  }


  render() {
    const { productId } = this.props;
    const {
      isEditing,
      isCreating,
      page
    } = this.state;
    const pageNumber = page || 1;

    const getData = async () => this.loadData(pageNumber || 1);

    return (
      <React.Fragment>
        {
          isEditing ? (
            <AriaModal
              titleText='Edit Field'
              mounted
              verticallyCenter={false}
              focusDialog
              getApplicationNode={() => document.getElementById('app')}
              dialogClass='dialog-size-normal'
              scrollDisabled
            >
              <EditProductField
                id={isEditing}
                close={refresh => {
                  this.setState({
                    isEditing: false
                  });

                  if (refresh) {
                    setTimeout(() => this.reloadList(), 0);
                  }
                }}
              />
            </AriaModal>
          ) : ''
        }
        {
          isCreating ? (
            <AriaModal
              titleText='Create Field'
              mounted
              verticallyCenter={false}
              focusDialog
              getApplicationNode={() => document.getElementById('app')}
              dialogClass='dialog-size-normal'
              scrollDisabled
            >
              <CreateProductField
                productId={productId}
                close={refresh => {
                  this.setState({
                    isCreating: false
                  });

                  if (refresh) {
                    setTimeout(() => this.reloadList(), 0);
                  }
                }}
              />
            </AriaModal>
          ) : ''
        }

        <ButtonOBSOLETED
          type='button'
          onClick={() => {
            this.setState({
              isCreating: true
            });
          }}
          buttonContent='Create new'
        />
        <br />
        <br />
        {
          this.shouldReloadList() ? this.reloadWorkaround()
            : (
              <DataTable
                style={{ marginTop: '100px' }}
                tableConfig={{
                  rowClick: ({ Id }) => {
                    this.setState({
                      isEditing: Id
                    });
                  },
                  rowClasses: 'hover-listview',
                  tableName: 'products',
                  columns: [
                    {
                      property: 'Id',
                      label: 'Id',
                      render: ({ Id }) => <DisplayGuid>{Id}</DisplayGuid>
                    },
                    {
                      property: 'Name',
                      label: 'Name'
                    },
                    {
                      property: 'Type',
                      label: 'Type',
                      render: ({ Type }) => <DisplayType>{Type}</DisplayType>
                    },
                    {
                      property: 'ProductId',
                      label: 'Product Id',
                      render: ({ ProductId }) => <DisplayGuid>{ProductId}</DisplayGuid>
                    },
                    {
                      property: 'IsRequired',
                      label: 'Is Required',
                      render: ({ IsRequired }) => <DisplayBoolean>{IsRequired}</DisplayBoolean>
                    }
                  ]
                }}
                getData={getData}
                paginationData={{
                  renderLocation: 'bottom',
                  rowsPerPage: resultsCount,
                  pageNumber,
                  goToPageNumber: number => {
                    this.setState({
                      page: number
                    });
                  }
                }}
                cellVerticalAlign='top'
                hideTableHead={false}
                languageCode='en'
                labels={{
                  tableBody: {
                    noResult: 'no results'
                  }
                }}
                cellContent='cellContent'
              />
            )
        }
      </React.Fragment>
    );
  }
}

const ProductFields = withRouter(withApi(
  connect(({ user, categories }) => ({ isLoggedIn: !!user, categories }), {})(ProductFieldsInternal)
));
ProductFields.requiresLogin = true;
ProductFields.propTypes = { isLoggedIn: PropTypes.bool };

export default ProductFields;